'use es6';

export var managePurchasesPrefetcher = function managePurchasesPrefetcher() {
  return import(
  /* webpackChunkName: 'chunk-manage-purchases' */
  '../containers/ManagePurchasesContainer');
};